import React from 'react';
import { Button, Sym } from '../../../components/app2';

/**
 * Barra de acciones masivas de Super Admins (rediseño jul-2026).
 *
 * Ahora aparece SOLO cuando hay usuarios seleccionados: antes ocupaba una
 * tarjeta permanente con un "Seleccionar todos" que ya vive en la cabecera de
 * la tabla y un recuadro de ayuda que repetía lo evidente.
 * El alta ("Agregar Super Admin") subió al encabezado de la pantalla.
 */
const UserActionsToolbar = ({ selectedCount = 0, onBulkDelete, onClearSelection }) => {
  if (!selectedCount) return null;

  const plural = selectedCount !== 1;

  return (
    <div
      className="a2-anim-fadein"
      style={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10,
        padding: '12px 20px', borderBottom: '1px solid var(--line)',
        background: 'var(--brand-soft)',
      }}
    >
      <Sym name="checklist" size={20} style={{ color: 'var(--brand-2)' }} />
      <span style={{ font: "600 .88rem 'Hanken Grotesk'", color: 'var(--heading)' }}>
        {selectedCount} Super Admin{plural ? 's' : ''} seleccionado{plural ? 's' : ''}
      </span>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginLeft: 'auto' }}>
        <Button variant="ghost" size="sm" icon="close" onClick={onClearSelection}>
          Quitar selección
        </Button>
        <Button variant="danger" size="sm" icon="delete" onClick={onBulkDelete}>
          Eliminar seleccionado{plural ? 's' : ''}
        </Button>
      </div>
    </div>
  );
};

export default UserActionsToolbar;
